export const mobileSwitcher = {
  layoutChanged: false,
  init() {
    this.menuElem = document.querySelector('.side-menu')
    this.listElem = document.querySelector(
      '.content-container-with-menu > .resolution-list-container'
    )
    this.reportElem = document.querySelector(
      '.content-container-with-menu > .resolution-report-container'
    )
    this.topBarElem = document.querySelector('.resolution-topBar')

    this.resizeHandlerBinded = this.resizeHandler.bind(this)
  },
  resizeHandler() {
    if (window.innerWidth > 750) {
      this.showList()
    }
  },
  showReport() {
    if (window.innerWidth <= 750) {
      this.init()

      // New platform nav dropped .side-menu and .resolution-topBar. Writing
      // `.style` on those missing nodes threw and blocked opening an incident
      // (IC-49684 #1). The list/report panes still exist — toggle those.
      if (this.menuElem) this.menuElem.style.display = 'none'
      if (this.topBarElem) this.topBarElem.style.display = 'none'
      if (this.listElem) this.listElem.style.display = 'none'
      if (this.reportElem) {
        this.reportElem.style.display = 'block'
        this.reportElem.style.left = '0'
      }

      this.layoutChanged = true

      // TODO: save scroll position of list

      window.addEventListener('resize', this.resizeHandlerBinded, true)
    }
  },
  showList() {
    if (this.layoutChanged) {
      if (this.menuElem) this.menuElem.style.display = 'block'
      if (this.topBarElem) this.topBarElem.style.display = ''
      if (this.listElem) this.listElem.style.display = ''
      if (this.reportElem) {
        this.reportElem.style.display = ''
        this.reportElem.style.left = ''
      }

      this.layoutChanged = false

      window.removeEventListener('resize', this.resizeHandlerBinded, true)
    }
  },
  toggleHistoryLayoutChange() {
    // related for tablet and less
    this.menuElem = document.querySelector('.side-menu')
    if (this.menuElem?.classList?.contains('mbz')) {
      this.menuElem.classList.remove('mbz')
    } else {
      // eslint-disable-next-line no-unused-expressions
      this.menuElem?.classList?.add('mbz')
    }
  },
}
